// 配置文件

var commonAddress4 = process.env.API_HOST_V4;
var commonAddress4S = process.env.API_HOST_V40S;

/** 各环境共用 */

var protocol = window.location.protocol;
commonAddress4 = protocol + commonAddress4;
commonAddress4S = protocol + commonAddress4S;

// 4.0企业级平台接口请求地址域名
var address = commonAddress4 + "/index.php/v4/client"; 

// 4.0接口请求公共地址域名
var commonAddress = commonAddress4 + "/index.php/v4"; 

// 企业平台自动登录请求地址
var epAutoLoginUrl = commonAddress4 + "/index.php/v4/Client/login/doLogin"; 

var commomHeaders = {
  "Content-Type": "application/json"
};

let naviMapList = {
  模块管理: "modulManage",
  第三方应用: "thirdApplication"
};

const API = {
  baseUrl: "http://183.235.186.174:8081/",
  frontUrl: "http://183.235.186.174:84/"
};

export {
  address,
  commonAddress,
  commonAddress4,
  commonAddress4S,
  epAutoLoginUrl,
  commomHeaders,
  naviMapList,
  API
};



//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = wAX/
// module chunks = 1